import React from "react";
import {JobApplicationDetails} from "@/data/entities/jobApplication";
import {DescriptionList, DescriptionListItem, SectionHeading, TextSkeleton} from "peggirkit";
import {FormattedMessage, useIntl} from "react-intl";

type Props = {
    jobApplication: JobApplicationDetails | undefined,
};

const GeneralDetails = ({jobApplication}: Props) => {
    const intl = useIntl();
    return (
        <>
            <SectionHeading
                title={<FormattedMessage id={"generalDetails"}/>}
                containerClassname={"!pb-0"}
            />

            <DescriptionList
                compact={true}
                stacked={false}
            >
                <DescriptionListItem
                    title={intl.formatMessage(({id: "jobTitle"}))}
                    content={
                        !jobApplication
                            ? <TextSkeleton/>
                            : intl.formatMessage({id: `jobTitle.${jobApplication.jobOpening.type}`})
                    }
                />

                <DescriptionListItem
                    title={intl.formatMessage(({id: "sentOn"}))}
                    content={
                        !jobApplication
                            ? <TextSkeleton/>
                            : new Date(jobApplication.creationDate).toLocaleString()
                    }
                />
            </DescriptionList>
        </>
    );
};

export default GeneralDetails;